// Local seed data can be added alongside this file without being committed.
// Production uses the backend APIs after application initialization.
export default {
  appData: {},
  eventsData: { events: [] },
  nudgesData: { nudges: [], tags: [], pager: { count: 0 } },
  outletsMenu: {},
  promotionData: {},
};
